import getLabels from '../getLabels/getLabels';
/*
  This function is meant to filter out options that mention retirement
  from the multi-select labels. It will be used when the user has
  previously selected they are retired.
*/

const itemsToFilter = {
  'Retiring early': 0,
  'Saving enough for retirement': 1,
};

export const filterRetirementOptions = (schema) => {
  // extract labels from schema
  const labels = getLabels(schema);

  // remove options if they are present in itemsToFilter
  return labels.filter((label) => itemsToFilter[label] === undefined);
};

export const filterRetirementAnswers = (answers) =>
  answers.filter((label) => itemsToFilter[label] === undefined);
